module.exports = __webpack_public_path__ + "img/colaborator.939b9535.png";